import { Box, Grid } from "@mui/material";
import React from "react";
import { APP_COLORS, ASSETS_PATH } from "../../utils/constants";
import SectionTitle from "../../components/Typography/SectionTitle";

export default function FounderSection({ id }) {
  return (
    <Box
      className="container-fluid"
      id={id}
      sx={{ my: { lg: 2 }, py: { xs: "50px", lg: 0 } }}
    >
      <Grid container sx={{ height: { lg: "57rem" }, overflow: "hidden" }}>
        <Grid
          size={{ xs: 12, md: 6 }}
          sx={{
            display: "flex",
            alignItems: "center",
            color: APP_COLORS.FONT,
            px: { lg: "5rem" },
          }}
        >
          <Box>
            <SectionTitle title="Marwa Khalaf" />

            <Box
              sx={{
                pt: 1.5,
                textAlign: { xs: "center", md: "left" },
              }}
            >
              <p style={{ fontSize: "20px", marginTop: 0 }}>Founder & CEO</p>
            </Box>

            <Box xs={{ display: { xs: "block", md: "none", xl: "none" } }}>
              <img
                className="mobile-only"
                src={ASSETS_PATH + "marwa.jpg"}
                alt="marwa-image"
                style={{ width: "100%" }}
              />
            </Box>

            <Box
              className="container"
              sx={{
                fontSize: "1rem",
                lineHeight: "1.7rem",
                fontWeight: { xs: 400, lg: 500 },
                paddingRight: { lg: "5rem" },
                // textAlign: { xs: "center", md: "left" },
                // textAlign: { xs: "justify", md: "left" },
              }}
            >
              <p
                style={{
                  marginTop: "3rem",
                }}
              >
                Marwa is a seasoned Business Strategist with over 20 years of
                experience in business growth, brand development, innovation,
                and organizational change. She has led transformation across
                both B2B and B2C sectors, combining analytical insight with
                creative execution to deliver lasting impact.
              </p>
              <p>
                Prior to co-founding rubicon®
                {/* <span
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: 700,
                    // transform: "translateY(10rem)",
                  }}
                >
                  &#174;
                </span> */}
                , she held senior leadership roles at minlo, where she
                spearheaded strategy and innovation for leading brands like
                Tank® and Koldair®. Her work has consistently shaped market
                leaders and driven brand equity in fast-moving and competitive
                industries.
              </p>
              <p>
                Today, Marwa advises on private equity ventures and business
                transformation projects, helping organizations navigate complex
                challenges and scale with purpose.
              </p>

              <p>
                Her multicultural upbringing across Europe and Egypt informs her
                global perspective, and her academic background includes an MBA
                in Marketing, a Board Certification from EIoD, and a degree in
                Accounting from Cairo University.
              </p>
            </Box>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Box xs={{ display: { xs: "none", lg: "visible" } }}>
            <img
              src={ASSETS_PATH + "marwa.jpg"}
              alt="marwa-image"
              className="lg-only"
              style={{ width: "100%" }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
